import { Gameplay, TIMER } from "./Gameplay";



export class GameplayTimer {
    static get instance(): GameplayTimer { return GameplayTimer._instance; }
    private static _instance: GameplayTimer;

    /**
     * Udalost vyvolana pri spusteni casovace
     * Emitter: Gameplay.events
     * Parametry:
     * this
     */
    static readonly EVENT_START = "timer:start";
    /**
     * Udalost vyvolana pri vyprseni casu
     * Emitter: Gameplay.events
     * Parametry:
     * this
     */
    static readonly EVENT_TIME_OUT = "timer:out";

    /**
     * (RO) Cas zahajeni hry
     */
    get startTime(): number { return this._startTime; }
    private _startTime: number;
    /**
     * (RO) Casovy limit na hru v ms
     */
    get timeLimit(): number { return this._timeLimit; }
    private _timeLimit: number;
    /**
     * (RO) Pocet zbyvajicich ms na hru
     */
    get timeLeft(): number { return this._timeLeft; }
    private _timeLeft: number;
    /**
     * (RO) Uplynuly cas v ms
     */
    get elapsedTime(): number { return this._timeLimit - this._timeLeft; }
    /**
     * (RO) True, pokud herni casovac bezi
     */
    get isStarted(): boolean { return this._startTime >= 0; }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(timeLimit: number) {
        GameplayTimer._instance = this;

        this._timeLimit = timeLimit;
        this.reset();
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    reset(): void {
        this._timeLeft = this._timeLimit;
        this._startTime = -1;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    start(startTime: number = TIMER.time): void {
        if (this._startTime < 0) {
            this._startTime = startTime;
            this._timeLeft = this._timeLimit;

            Gameplay.instance.events.fire(GameplayTimer.EVENT_START, this);
        }
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    stop(): void {
        this._startTime = -1;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    update(): void {
        if (this._startTime < 0)
            return;

        if (this._timeLimit > 0 && (this._timeLeft = this._timeLimit - (TIMER.time - this._startTime)) <= 0) {
            this._timeLeft = 0;
            this._startTime = -1;

            Gameplay.instance.events.fire(GameplayTimer.EVENT_TIME_OUT, this);
        }
    }
}